import { useQuery, UseQueryOptions } from 'react-query'

import { AxiosError } from 'axios'
import ApiCall from 'services/ApiCall'

import useUrlQuery, { UseUrlQueryOptions } from 'helpers/QueryUrl/useUrlQuery'

export interface HalamanGetSequences {
  id: number
  tittle: string
  description: string
}

type UseSequencesResult = {
  total: any
  data: any
  result: HalamanGetSequences[]
}

type TQueryFnData = UseSequencesResult
type TError = AxiosError

function useGetAllHalaman(
  page: number,
  pageSize: number,
  filter?: any,
  urlOptions?: UseUrlQueryOptions,
  options?: UseQueryOptions<TQueryFnData, TError>,
) {
  const urlQuery = useUrlQuery(urlOptions)
  const query = useQuery<TQueryFnData, TError>(
    urlQuery.transformKey(`/get-all-halaman-${page}-${pageSize}-${JSON.stringify(filter)}`),
    () =>
      ApiCall.Halaman.get(page, pageSize, filter).then((res) => {
        return res.data
      }),
    {
      ...options,
      keepPreviousData: true,
    },
  )

  return {
    ...query,
    data: query?.data?.data,
    length: query?.data?.total,
    helpers: urlQuery,
  }
}

export default useGetAllHalaman
